export const multiPrintStatuses =
{
    1: "bulk.uploading-file",
    2: "bulk.uploading-file-success",
    3: "status.printing",
    4: "status.completed",
    5: "bulk.uploading-error"
}

export enum multiPrintState {
    downloadingFile = 1,
    downloadingFileSuccess = 2,
    printing = 3,
    printingComplete = 4,
    error = 5
}